import React from "react";
import "./Button.scss";

export default function Button({text, className, href, newTab, active=null,ifOnClick=null,onClick=null }) {
  return (
    <div>
    <div className={className}>
      <a className={`main-button ${ active ==true? 'active-button' :null}`} onClick={ifOnClick? onClick:null} href={href} target={newTab && "_blank"}>
        {text}
      </a>
    </div>
    <div className={active==true?"active-line":null}></div>
    </div>
  );
}
